(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Handle hash navigation
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Search filter functionality
  document.addEventListener('DOMContentLoaded', function() {
    const searchInput = document.getElementById('fragrance-search');
    const clearButton = document.getElementById('clear-search');
    const resultsCount = document.getElementById('search-results-count');
    
    if (!searchInput) return;

    // Ensure clear button starts hidden (CSS handles opacity/visibility).
    clearButton.classList.remove('visible');
    clearButton.setAttribute('aria-hidden', 'true');
    resultsCount.style.display = 'none';

    function updateClearVisibility(visible) {
      if (visible) {
        clearButton.classList.add('visible');
        clearButton.setAttribute('aria-hidden', 'false');
      } else {
        clearButton.classList.remove('visible');
        clearButton.setAttribute('aria-hidden', 'true');
      }
    }

    function filterProducts() {
      const searchTerm = searchInput.value.toLowerCase().trim();
      const products = document.querySelectorAll('.searchable-product');
      let visibleCount = 0;
      
      products.forEach(product => {
        const title = product.getAttribute('data-product-title') || '';
        const vendor = product.getAttribute('data-product-vendor') || '';
        const type = product.getAttribute('data-product-type') || '';
        
        const searchableText = `${title} ${vendor} ${type}`;
        
        if (searchTerm === '' || searchableText.includes(searchTerm)) {
          product.style.display = '';
          visibleCount++;
        } else {
          product.style.display = 'none';
        }
      });
      
      // Update clear button visibility and results count
      if (searchTerm) {
        updateClearVisibility(true);
        resultsCount.textContent = `${visibleCount} product${visibleCount !== 1 ? 's' : ''} found`;
        resultsCount.style.display = 'block';
      } else {
        updateClearVisibility(false);
        resultsCount.style.display = 'none';
      }
    }
    
    searchInput.addEventListener('input', filterProducts);
    
    clearButton.addEventListener('click', function() {
      searchInput.value = '';
      filterProducts();
      searchInput.focus();
    });

    // allow Escape key to clear
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        searchInput.value = '';
        filterProducts();
        searchInput.blur();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
